import i18n from '@/i18n';
import Gasstation from './Gasstation';
import Employee from './Employee';
import Petrol from './Petrol';
import Preferential from './Preferential';
import Commission from './Commission';
import League from './League'; //$IMPORT$
import GasstationRule from './GasstationRule';
import PushList from './PushList';
import StationLog from '@/pages/gasstation/StationLog';

export default () => [
  {
    resourceName: i18n.t('gasstation-index-1992f2b7fa2c72d45-1'),
    routerUrl: '/gasstation',
    resourceIcon: '',
    type: '0',
    buttons: [],
    children: [
      Gasstation(),
      Employee(),
      Petrol(),
      Preferential(),
      Commission(),
      League(), //$MORE$
      GasstationRule(),
      PushList(),
      StationLog(),
    ],
  },
];
